import React, { useState } from "react";
import Spinner from "../../../components/Spinner";
import useUpdateDoc from "../../../hooks/useUpdateDoc";
import { formatCurrencyTable } from "../../../utils/formatCurrencyTable";
import { planPagos } from "../../../utils/planPagos";
import { formatCurrency } from "../../../utils/formatCurrency";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../FirebaseConfig.ts";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import useInsertDoc from "../../../hooks/useInsertDoc.js";
import ModalPago from "./modalPago.js";

dayjs.extend(isSameOrAfter);

function TablePagos({
  landing,
  loading,
  schedule,
  payment,
  data,
  investor,
  investorData,
  disabled,
}) {
  const { schedule: schedule2 } = planPagos(
    data,
    investor ? data.tasaInvestor : null
  );

  const [modalPago, setModalPago] = useState(false);
  const [deletePago, setDeletePago] = useState(false);
  const [currentPayment, setCurrentPayment] = useState({});

  const [isSaving, setIsSaving] = useState(false);
  const [date, setDate] = useState(dayjs().format("YYYY-MM-DD"));

  const { handleUpdate } = useUpdateDoc();
  const { handleInsert } = useInsertDoc();

  const isPaymentForSofia = dayjs(data?.start_date).isSameOrAfter(
    dayjs("2025-10-28"),
    "day"
  );

  const handleUpdatePayment = async (payment) => {
    const formatted = dayjs(payment.fechaPago, "DD/MM/YYYY").format(
      "YYYY-MM-DD"
    );
    const isInvestor = Boolean(investor);
    setIsSaving(true);

    // Determinar plan actual (última versión de abono)
    const currentPlanVersion =
      payment?.paymentInfo?.planVersion || payment?.planVersion || 1;

    const currentPayments = Array.isArray(data?.payments) ? data.payments : [];

    const currentPaymentsInvestor = Array.isArray(data?.paymentsInvestor)
      ? data.paymentsInvestor
      : [];

    const idStr = payment?.cuota?.toString();
    const exists = currentPayments.some(
      (p) => p.id === idStr && p.planVersion === currentPlanVersion
    );
    const existsI = currentPaymentsInvestor.some(
      (p) => p.id === idStr && p.planVersion === currentPlanVersion
    );
    let newPayments;
    let newPaymentsI;

    const cuota =
      Number(schedule2[payment?.cuota || 0]?.cuotaAPagar?.toFixed(0)) || 0;

    if (exists) {
      // 🔹 Eliminar pago existente
      newPayments = currentPayments.filter(
        (p) => !(p.id === idStr && p.planVersion === currentPlanVersion)
      );
    } else {
      // 🔹 Agregar nuevo pago
      const newPayment = {
        id: idStr,
        installment: payment.cuota, // número de cuota
        amount: payment.cuotaAPagar,
        date: formatted,
        planVersion: currentPlanVersion,
        source: "manual",
      };

      newPayments = [...currentPayments, newPayment];
    }

    if (existsI) {
      // 🔹 Eliminar pago existente
      newPaymentsI = currentPayments.filter(
        (p) => !(p.id === idStr && p.planVersion === currentPlanVersion)
      );
    } else {
      // 🔹 Agregar nuevo pago

      const newPaymentI = {
        id: idStr,
        installment: payment.cuota, // número de cuota
        amount: cuota,
        date: formatted,
        planVersion: currentPlanVersion,
        source: "manual",
      };

      newPaymentsI = [...currentPaymentsInvestor, newPaymentI];
    }

    // Armar el objeto con la clave adecuada según si es investor o no
    const paymentsData = {
      payments: newPayments,
      paymentsInvestor: newPaymentsI,
    };

    if (data?.investorId && investorData) {
      const investorCollection = collection(db, "investor");

      const qL = query(
        investorCollection,
        where("uuid", "==", "gyorAaGrlQRBwA1jA6a4")
      );
      const qS = query(
        investorCollection,
        where("uuid", "==", "icQvajUVgZfA0BEuP26p")
      );

      const [dataL, dataS] = await Promise.all([getDocs(qL), getDocs(qS)]);
      const lendyInvestor = dataL.docs[0]?.data();
      const sofiaInvestor = dataS.docs[0]?.data();

      const cuotaNormal = Number(schedule[0]?.cuotaAPagar?.toFixed(0)) || 0;
      const currentAmount = Number(investorData?.currentAmmount) || 0;
      const valorSumaInvestor = cuotaNormal - cuota;

      // Si se quita un pago, se resta; si se agrega, se suma
      const newAmount = exists
        ? currentAmount - cuota // se quitó el pago
        : currentAmount + cuota; // se agregó el pago

      const montoLendy = valorSumaInvestor;
      const montoSofia = Number(montoLendy) * 0.01;

      if (newAmount >= 0) {
        handleUpdate("investor", data.investorId, {
          currentAmmount: newAmount,
        });

        handleUpdate("investor", lendyInvestor?.uuid, {
          currentAmmount: exists
            ? Number(lendyInvestor?.currentAmmount || 0) -
              Number(montoLendy || 0)
            : Number(lendyInvestor?.currentAmmount || 0) +
              Number(montoLendy || 0),
        });

        const movementData = {
          investorId: lendyInvestor?.uuid,
          investorName: lendyInvestor.name,
          type: "egreso_pago",
          amount: montoLendy,
          detail: "",
          creditId: null,
          creditData: {
            name: `${data.name} `,
            lastName: `${data.lastName}`,
            identity: `${data.identity}`,
            numberCredit: `${data.numberCredit}`,
          },
          date: `${dayjs().format("DD/MM/YYYY")}`,
          status: "completado",
          description: `Pago removido del crédito de ${data.name} ${
            data.lastName
          } por valor de ${formatCurrency(Number(montoLendy))}`,
        };

        await handleInsert("investorMovements", {
          ...movementData,
        });

        if (isPaymentForSofia) {
          handleUpdate("investor", sofiaInvestor?.uuid, {
            currentAmmount: exists
              ? Number(sofiaInvestor?.currentAmmount || 0) -
                Number(montoSofia || 0)
              : Number(sofiaInvestor?.currentAmmount || 0) +
                Number(montoSofia || 0),
          });

          const movementData2 = {
            investorId: sofiaInvestor?.uuid,
            investorName: sofiaInvestor.name,
            type: "egreso_pago",
            amount: montoSofia,
            detail: "",
            creditId: null,
            creditData: {
              name: `${data.name} `,
              lastName: `${data.lastName}`,
              identity: `${data.identity}`,
              numberCredit: `${data.numberCredit}`,
            },
            date: `${dayjs().format("DD/MM/YYYY")}`,
            status: "completado",
            description: `Pago removido del crédito de ${data.name} ${
              data.lastName
            } por valor de ${formatCurrency(Number(montoSofia))}`,
          };

          await handleInsert("investorMovements", {
            ...movementData2,
          });
        }
      }
    }

    // --- Verificar si todos los pagos están hechos ---
    const allPaymentsMade = newPayments.length === Number(schedule.length);
    const updateData = {
      ...paymentsData,
    };

    if (allPaymentsMade) {
      updateData.status = "pagado";
      updateData.fechaPagoCompleto = formatted;
    }

    handleUpdate("requests", data?.uuid, updateData);
    setIsSaving(false);
    setModalPago(false);
    setDeletePago(false);
    setCurrentPayment({});
  };

  return (
    <>
      <ModalPago
        modalPago={modalPago}
        setModalPago={setModalPago}
        data={data?.abono}
        requestId={data?.uuid}
        investor={investor?.[0]}
        handleUpdatePayment={handleUpdatePayment}
        currentPayment={currentPayment}
        isSaving={isSaving}
        date={date}
        setDate={setDate}
        setDeletePago={setDeletePago}
        deletePago={deletePago}
      />
      <table className=" w-full text-sm text-left rtl:text-right text-gray-500 overflow-hidden">
        <thead
          className={`${
            landing ? "bg-info" : "text-gray-700 bg-gray-50"
          } text-xs  uppercase overflow-hidden`}
        >
          <tr>
            <th className="px-6 py-3">Cuotas</th>
            <th className="px-6 py-3">Fecha de descuento</th>
            <th className="px-6 py-3">Valor préstamo</th>
            <th className="px-6 py-3">Cuota a pagar</th>
            <th className="px-6 py-3">Capital</th>
            <th className="px-6 py-3">Interés</th>
            <th className="px-6 py-3">Saldo deuda</th>
            {payment && <th className="px-6 py-3">Pago</th>}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr className="">
              <td colSpan="100%" className="text-center">
                <Spinner />
              </td>
            </tr>
          ) : (
            schedule.map((row, index) => {
              const dataP = investor ? data?.paymentsInvestor : data?.payments;
              const ifPayment = dataP?.some(
                (el) => Number(el.installment) === index + 1
              );

              return (
                <tr
                  className={`${
                    landing ? " text-black border-primary" : "bg-white"
                  }  border-b`}
                  key={row.cuota}
                >
                  <td className="px-6 py-4">{row.cuota}</td>
                  <td className="px-6 py-4">
                    {row.fechaPago === "Invalid Date" ? "" : row.fechaPago}
                  </td>
                  <td className="px-6 py-4">
                    ${formatCurrencyTable(row.valorPrestamo)}
                  </td>
                  <td className="px-6 py-4">
                    ${formatCurrency(row.cuotaAPagar)}
                  </td>
                  <td className="px-6 py-4">${formatCurrency(row.capital)}</td>
                  <td className="px-6 py-4">${formatCurrency(row.interes)}</td>
                  <td className="px-6 py-4">
                    ${formatCurrency(row.saldoDeuda)}
                  </td>
                  {payment && (
                    <td className="px-6 py-4">
                      <div
                        onClick={
                          disabled || isSaving
                            ? () => null
                            : () => {
                                // setModalPago(true);
                                setCurrentPayment(row);
                                setDeletePago(ifPayment ? true : false);
                                setModalPago(ifPayment ? true : false);

                                if (!ifPayment) {
                                  handleUpdatePayment(row);
                                }
                              }
                        }
                        className={`${
                          disabled || isSaving
                            ? "cursor-not-allowed"
                            : "cursor-pointer"
                        } rounded-full  w-5 h-5 border-gray-700  ${
                          investor
                            ? ifPayment
                              ? "bg-blue-700"
                              : "border"
                            : row.payment || ifPayment
                            ? "bg-blue-700"
                            : "border"
                        } `}
                      />
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </>
  );
}

export default TablePagos;
